import { render, staticRenderFns } from "./TrialItem.vue?vue&type=template&id=21ce652e&scoped=true"
import script from "./TrialItem.vue?vue&type=script&lang=js"
export * from "./TrialItem.vue?vue&type=script&lang=js"
import style0 from "./TrialItem.vue?vue&type=style&index=0&id=21ce652e&prod&lang=css"
import style1 from "./TrialItem.vue?vue&type=style&index=1&id=21ce652e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ce652e",
  null
  
)

export default component.exports